export default "__VITE_ASSET__48b64a95__"